import { Stack } from "@mantine/core"
import { keepPreviousData } from "@tanstack/react-query"
import { ErrorBox, Loader } from "@tfg/ui"
import { useState } from "react"

import { HeaderControlsProvider } from "~/components/contexts/useHeaderControlsContext"
import {
  FindProductionSitesForBrandsResponseDto,
  useFindProductionSitesForBrands,
} from "~/gen/api"
import { usePaginatedQuery } from "~/hooks/usePaginatedQuery"
import { SupplierProductionSites } from "~/pages/Brand/Suppliers/List/SupplierProductionSites/SupplierProductionSites.tsx"
import { useBuildProductionSiteFilters } from "~/pages/SupplierPortal/ProductionSites/hooks/useBuildProductionSiteFilters"
import { useBuildProductionSiteSorts } from "~/pages/SupplierPortal/ProductionSites/hooks/useBuildProductionSiteSorts"

const SupplierProductionSitesWrapperContent = () => {
  const [searchProductionSite, setSearchProductionSite] = useState<string>("")
  const {
    filtersValue,
    setFiltersValue,
    options: filterOptions,
  } = useBuildProductionSiteFilters({
    forBrand: true,
  })
  const {
    sorts,
    setSorts: setProductionSiteSorts,
    options: sortOptions,
  } = useBuildProductionSiteSorts()
  const {
    data,
    isPending,
    isFetching,
    isError,
    error,
    pageBasedPagination,
    setPageBasedPagination,
  } = usePaginatedQuery<
    typeof useFindProductionSitesForBrands,
    FindProductionSitesForBrandsResponseDto
  >(
    useFindProductionSitesForBrands,
    {
      filters: filtersValue,
      sorts,
    },
    {
      query: {
        placeholderData: keepPreviousData,
      },
    }
  )

  return (
    <Stack gap="md">
      <Stack gap="xs">
        {isPending ? (
          <Loader fullPage />
        ) : isError ? (
          <ErrorBox title={error?.message ?? "Error"} error={error} />
        ) : (
          <SupplierProductionSites
            productionSitesData={data}
            filtersValue={filtersValue}
            isFetching={isFetching}
            setPagination={setPageBasedPagination}
            pagination={pageBasedPagination}
            setFiltersValue={setFiltersValue}
            setProductionSiteSorts={setProductionSiteSorts}
            productionSiteSorts={sorts}
            filterOptions={filterOptions}
            sortOptions={sortOptions}
            searchProductionSites={searchProductionSite}
            setSearchProductionSites={setSearchProductionSite}
          />
        )}
      </Stack>
    </Stack>
  )
}

export const SupplierProductionSitesWrapper = () => {
  return (
    <HeaderControlsProvider>
      <SupplierProductionSitesWrapperContent />
    </HeaderControlsProvider>
  )
}
